import api from './api';
import { USER_SUBSCRIPTIONS, SUBSCRIPTION_CHANGE, PLAN_VALIDATION } from '../config/Config';

export const validatePlanChange = async (planCode) => {
  try {
    const response = await api.get(`${PLAN_VALIDATION}?plan_code=${planCode}`);
    return response.data;
  } catch (error) {
    return { can_switch: false, message: 'Validation failed' };
  }
};

export const getSubscriptionHistory = async () => {
  try {
    const response = await api.get(USER_SUBSCRIPTIONS);
    return response.data;
  } catch (error) {
    return [];
  }
};

export const changeSubscription = async (planCode, changeReason = 'User initiated change') => {
  try {
    const response = await api.post(SUBSCRIPTION_CHANGE, {
      plan_code: planCode,
      change_reason: changeReason
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getCurrentSubscription = async () => {
  try {
    const response = await api.get(USER_SUBSCRIPTIONS);
    const subscriptions = response.data;
    return subscriptions.find(sub => sub.is_active) || null;
  } catch (error) {
    return null;
  }
}; 